import * as React from 'react';
import {
    Cube20Regular,
    AppsList20Regular,
    HardDrive20Regular,
    Home20Regular,
    ArrowTrendingLines20Regular,
    Settings20Regular,
    BookOpen20Regular,
    Megaphone20Regular,
    MusicNote220Regular,
    Pen20Regular,
    TextBulletListLtr20Regular,
    Warning20Regular,
    Receipt20Regular,
    Person20Regular
} from '@fluentui/react-icons';
import type { FluentIcon } from '@fluentui/react-icons';
import { MenuIconKey } from '../../types/MenuIconKey';
import { CCircle20Regular } from './customIcons/CCircle20Regular';



const MENU_ICONS: Record<MenuIconKey, FluentIcon> = {
    home: Home20Regular,
    settings: Settings20Regular,
    groupedList: AppsList20Regular,
    hardDrive: HardDrive20Regular,
    financial: ArrowTrendingLines20Regular,
    cube: Cube20Regular,
    receipt: Receipt20Regular,
    cCircle: CCircle20Regular,
    musicNoteList: MusicNote220Regular,
    pen: Pen20Regular,
    listUl: TextBulletListLtr20Regular,
    megaphone: Megaphone20Regular,
    exclamationTriangle: Warning20Regular,
    book: BookOpen20Regular,
    person: Person20Regular
};

function isMenuIconKey(value: string): value is MenuIconKey {
    return Object.prototype.hasOwnProperty.call(MENU_ICONS, value);
}

interface IMenuIconProps {
    iconKey?: string | null;
    className?: string;
}

export const MenuIcon: React.FC<IMenuIconProps> = ({ iconKey, className }) => {
    if (!iconKey || !isMenuIconKey(iconKey)) {
        return null;
    }

    const Icon = MENU_ICONS[iconKey];

    return (
        <Icon
            className={['icon', 'menuIcon', className].filter(Boolean).join(' ')}
            aria-hidden="true"
            focusable="false"
        />
    );
};
